export default __webpack_public_path__ + "static/media/splash-2.8e4f4105.png";